import { createCrewLookupSelect } from './createCrewLookupSelect';

/** Active ranks, ordered by sortOrder. */
export const RankSelect = createCrewLookupSelect('RankSelect', 'ranks');
export default RankSelect;
